/**
 * Weather module manifest — single source of truth for the module's identity
 * and version. Bump `version` (semver) whenever the module's behaviour or
 * public API changes, and add a matching entry to `CHANGELOG.md`.
 *
 * The version is surfaced in the Environment tool card so testers can confirm
 * which build of the weather module they are looking at.
 */

export const WEATHER_MODULE = {
  name: 'weather',
  /** semver — bump with every meaningful change (see CHANGELOG.md). */
  version: '0.2.0',
} as const;

export const WEATHER_MODULE_VERSION = WEATHER_MODULE.version;
